export interface UserNote {
    UserNoteValue: number
}

export function constructorUserNote(): UserNote {
    return {
        UserNoteValue: 0
    }
}